<p-table #dtDic [value]="solicitudDictamenes" [columns]="cols" responsiveLayout="scroll" [rows]="10"
         [globalFilterFields]="['numeroExpediente','usuario','estado']"
         [paginator]="true" [rowsPerPageOptions]="[10,25,50]" [showCurrentPageReport]="true"
         [styleClass]="'p-datatable-sm'"
         currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} dictamenes"
         selectionMode="multiple" [rowHover]="true" dataKey="id">
    <ng-template pTemplate="caption">
        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 class="m-0">Dictamenes: ({{ solicitudDictamenes.length }})</h5>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="numeroExpediente">Ref dictamen
                <p-sortIcon field="numeroExpediente"></p-sortIcon>
            </th>
            <th pSortableColumn="estado">Estado
                <p-sortIcon field="estado"></p-sortIcon>
            </th>
            <th pSortableColumn="usuario">Usuario
                <p-sortIcon field="usuario"></p-sortIcon>
            </th>
            <th pSortableColumn="fechaCreacion">Fecha
                <p-sortIcon field="fechaCreacion"></p-sortIcon>
            </th>
            <th>Opción</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-dictamenes>
        <tr>
            <td>
                <span class="p-column-title">Ref dictamen</span>
                  {{ dictamenes.numeroExpediente }}
            </td>
            <td>
                <span class="p-column-title">Estado</span>
                <p-tag [style]="tagStyle(dictamenes.estado)"
                       [value]="dictamenes.estado==true?'Activo':'Inactivo'"></p-tag>
            </td>
            <td>
                <span class="p-column-title">Usuario</span>
                {{ dictamenes.usuario }}
            </td>
            <td>
                <span class="p-column-title">Fecha</span>
                {{ dictamenes.fechaCreacion }}
            </td>
            <td>
                <p-button icon="pi pi-eye" class="p-button-rounded mr-2"
                          [rounded]="true" [outlined]="true"
                          pTooltip="Ver dictamen" severity="info"
                        (onClick)="openDialogReadonly(dictamenes)"></p-button>
            </td>
        </tr>
    </ng-template>
</p-table>

<ng-container *ngIf="this.openDialog">
    <app-notificar-solicitud-obs [openDialog]="this.openDialog" [titleHeader]="'INFORMACIÓN DICTAMEN'" [textReadOnly]="true"
                                 [type]="EvaluacionEstadosControl.Dictamen" [evaluaciones]="this.evaluacioneService.evaluaciones()"
                                 [infoDictamen]="this.seletedDictamen" [selected]="selected!"
                                 (onEventEmitterClose)="onDialogClosed($event)"></app-notificar-solicitud-obs>
</ng-container>

